import { Divider, Modal, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { GovEvalMinStdSchema, GovEvaluationMinimalStandardForm } from './GovEvaluationMinimalStandardForm';

interface GovEvaluationMinimalStandardModalProps {
  onSubmit: (v: GovEvalMinStdSchema) => void;
  isSubmitting: boolean;
  onClose: () => void;
}

export function GovEvaluationMinimalStandardModalForm(props: GovEvaluationMinimalStandardModalProps) {
  const { onClose, isSubmitting, onSubmit } = props;
  const { t } = useTranslation();

  return (
    <Modal
      opened
      centered
      size="xl"
      onClose={onClose}
      title={t('govEvaluation.minimalStandard')}
    >
      <Stack>
        <div>automatizare</div>
        <Divider />
        <GovEvaluationMinimalStandardForm
          onSubmit={onSubmit}
          isSubmitting={isSubmitting}
          onClose={onClose}
        />
      </Stack>
    </Modal>
  );
}
